import { makeStyles } from '@mui/styles';

import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
  dropzone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '32px 16px',
    border: `2px dashed ${STYLE.COLOR.ACCENT_PRIMARY_LIGHTER2}`,
    borderRadius: '12px',
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_DISABLED,
    },
  },
  disabled: {
    cursor: 'not-allowed',
    opacity: 0.6,
    '&:hover': {
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    },
  },
  fileIcon: {
    fontSize: '40px !important',
    color: STYLE.COLOR.ERROR + ' !important',
  },
  uploadText: {
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
    textAlign: 'center',
  },
  uploadHintPrefix: {
    color: STYLE.COLOR.TEXT2,
  },
  uploadHint: {
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
  },
  maxFilesHint: {
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  hiddenInput: {
    display: 'none',
  },
  filesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '12px 16px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: '12px',
    backgroundColor: STYLE.COLOR.WHITE,
  },
  fileName: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0,
  },
  removeButton: {
    padding: '4px !important',
    flexShrink: 0,
  },
}));
